import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Calendar } from "primereact/calendar";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  addCustomerBalance,
  getCustomers,
  getspecificCustomer,
} from "../../store/AsyncMethods/CustomerMethod";
import { Card } from "primereact/card";

import * as Yup from "yup";

export default function CustomerBalance({ customer }) {
  const { enableCurrency } = useSelector((state) => state.CurrencyReducer);
  const { allCustomers } = useSelector((state) => state.CustomersReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCustomers());
  }, []);

  const { t } = useTranslation();
  const formik = useFormik({
    initialValues: {
      customer: "",
      date: new Date(),
      siteId: "",
      creditAmount: null,
      debitAmount: null,
      currencyId: enableCurrency?.currency_id || 1,
    },
    validationSchema: Yup.object({
      // creditAmount: Yup.number().required("Credit Amount Required"),
      // debitAmount: Yup.number().required("Debit Amount Required"),
    }),

    onSubmit: async (values) => {
      const data = {
        ...values,
        creditAmount: Number(values.creditAmount || 0),
        debitAmount: Number(values.debitAmount || 0),
      };
      dispatch(addCustomerBalance(data)).then((success) => {
        if (success) {
          formik.resetForm();
          dispatch(getspecificCustomer(customer.id));
        }
      });
    },
  });

  useEffect(() => {
    if (customer) {
      console.log("Customer:", customer);
      const openingDate = customer.openingDate
        ? new Date(customer.openingDate)
        : new Date();
      formik.setValues({
        ...formik.values,
        customer: customer.id,
        name: customer.name,
        date: openingDate,
        creditAmount: null,
        debitAmount: null,
      });
    }
  }, [customer]);

  return (
    <div className="card shadow-md rounded-lg p-4 mt-1">
      <Divider>
        <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
          {t("customer_opening_balance")}
        </span>
      </Divider>

      <form onSubmit={formik.handleSubmit}>
        <div className="px-4 gap-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2">
          <div className="">
            <div className="flex flex-col gap-2">
              <label htmlFor="name" className="">
                {t("name")}
              </label>
              <span className=" w-full">
                <InputText
                  disabled
                  id="name"
                  name="name"
                  className="w-full text-lg p-primary-input"
                  value={formik.values?.name}
                  onChange={formik.handleChange}
                />
              </span>
            </div>
          </div>

          <div className="">
            <div className="flex flex-col gap-2">
              <label htmlFor="creditAmount" className="">
                {t("credit_amount")}
              </label>
              <span className=" w-full">
                <InputNumber
                  id="creditAmount"
                  name="creditAmount"
                  className="w-full text-lg p-primary-input"
                  placeholder="0"
                  value={formik.values.creditAmount}
                  onValueChange={(e) => {
                    formik.setFieldValue(
                      "creditAmount",
                      e.value === 0 ? null : e.value
                    );
                  }}
                  prefix={`${enableCurrency?.unit || ""} `}
                />
              </span>
            </div>
            {formik.touched?.creditAmount && formik.errors?.creditAmount && (
              <div className="p-error">{formik.errors?.creditAmount}</div>
            )}
          </div>

          <div className="">
            <div className="flex flex-col gap-2">
              <label htmlFor="debitAmount" className="">
                {t("debit_amount")}
              </label>
              <span className=" w-full">
                <InputNumber
                  id="debitAmount"
                  name="debitAmount"
                  placeholder="0"
                  className="w-full text-lg p-primary-input"
                  value={formik.values.debitAmount}
                  onValueChange={(e) => {
                    formik.setFieldValue(
                      "debitAmount",
                      e.value === 0 ? null : e.value
                    );
                  }}
                  prefix={`${enableCurrency?.unit || ""} `}
                />
              </span>
            </div>
            {formik.touched?.debitAmount && formik.errors?.debitAmount && (
              <div className="p-error">{formik.errors?.debitAmount}</div>
            )}
          </div>

          <div className=" ">
            <div className="flex flex-col gap-2 p-fluid">
              <label htmlFor="date" className="">
                {t("open_balance_date")}
              </label>

              <Calendar
                dateFormat="yy/mm/dd"
                id="date"
                onChange={formik.handleChange}
                className=" w-full calender p-primary-cld-btn"
                value={formik.values.date}
                showIcon
              />
            </div>
            {formik.touched?.date && formik.errors?.date && (
              <div className="p-error">{formik.errors?.date}</div>
            )}
          </div>

          {/* <div className="mt-16">
            <div className="flex justify-end gap-4">
              <Button
                label={t("cancel")}
                icon="pi pi-times"
                className="p-red-btn"
                type="button"
                onClick={() => {
                  formik.resetForm();
                }}
              />
              <Button
                label={t("submit")}
                type="submit"
                icon="pi pi-check"
                className="p-secondary-btn"
              />
            </div>
          </div> */}
          <div className="mt-8">
            <div className="flex justify-end gap-4 right-11 absolute">
              <Button
                label={t("cancel")}
                icon="pi pi-times"
                className="p-red-btn"
                type="button"
                onClick={() => {
                  formik.resetForm();
                }}
              />
              <Button
                label={t("submit")}
                icon="pi pi-check"
                className="p-secondary-btn"
              />
            </div>
          </div>
        </div>
      </form>
      <Card className="shadow-md">
        <div className="p-4">
          <h3 className="text-xl font-semibold mb-4">
            {t("Balance Information")}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div
              className="p-4 border rounded-lg"
              style={{ backgroundColor: "var(--green-50)" }}
            >
              <div className="flex justify-between items-center">
                <span className="font-medium text-green-700">
                  {t("credit_amount")}
                </span>
                <span className="text-xl font-bold p-font-style text-green-700">
                  {enableCurrency?.unit} {customer?.creditAmount || 0}
                </span>
              </div>
            </div>

            <div
              className="p-4 border rounded-lg"
              style={{ backgroundColor: "var(--red-50)" }}
            >
              <div className="flex justify-between items-center">
                <span className="font-medium text-red-700">
                  {t("debit_amount")}
                </span>
                <span className="text-xl font-bold p-font-style text-red-700">
                  {enableCurrency?.unit} {customer?.debitAmount || 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
